import React, { Component } from 'react';
import './SessionQAndAs.css';
import QandAComponent from '../../../../../Components/QandAComponent/QandAComponent';
import { connect } from 'react-redux';
import Pagination from '@getgo/chameleon-react/dist/Pagination';
import { actions as sessionQuestionsActions } from '../../../../../Reducks/SessionQuestions';
import PropTypes from 'prop-types';
import SimpleSearchBox from '../../../../../Components/SearchBox/SimpleSearchBox';
import Menu from '../../../../../Components/Menu/Menu';
import {
  ENGAGEMENT_DETAILS,
  FILTER_QANDA,
  PAGINATE_QANDA,
  QUESTIONS_SEARCH,
  SORT_QANDA,
  VALUE_ADD
} from '../../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { getQAndAMenuItems } from '../../../../../Components/Menu/MenuItemsHelper';
import { QAndAAnsweredOptions, SortOrder } from '../../../../../Utils/Constants';
import { HeaderSortComponent } from '../../../../../Scss/Custom/ReactTable/HeaderSortComponent';
import { showGenericSkeletonScreen } from '../../../../../SkeletonScreens/SkeletonScreen';
import {
  trackAnalyticsFeature,
  trackAnalyticsFilterType
} from '../../../../../Telemetry/Mixpanel/Features/analyticsTracker';

export class SessionQAndAs extends Component {
  static propTypes = {
    sessionKey: PropTypes.string,
    isBig: PropTypes.bool,
    reduced_session_questions: PropTypes.object,
    reduced_session_details: PropTypes.object
  };
  static contextTypes = {
    t: PropTypes.func
  };

  render() {
    const { fetching } = this.props.reduced_session_questions;
    return (
      <React.Fragment>
        <div className="sessionQAndAsEngagement">{this.searchAndFilterComponent()}</div>
        <div className="engagementModalContent">
          {fetching ? showGenericSkeletonScreen() : this.qAndAListComponent()}
        </div>
        <div className="engagementModalFooter">{this.paginationComponent()}</div>
      </React.Fragment>
    );
  }

  searchAndFilterComponent() {
    const { t } = this.context;
    const { filter } = this.props.reduced_session_questions;
    return (
      <div className="searchAndFilterComponent">
        <div className="sessionQAndASearchBox">
          <SimpleSearchBox
            placeHolder={t('engagement.qandaSearch')}
            onSearchInputChange={searchTerm => this.fetchQuestions(0, { textSearch: searchTerm })}
            mixpanelData={{ action: ENGAGEMENT_DETAILS, searchType: QUESTIONS_SEARCH }}
          />
        </div>
        <div className="filterSortGroup">
          <button
            className={`custom-buttons-chameleon outline-button sort-${
              filter.dateAskedSortOrder === SortOrder.ASC ? 'asc' : 'desc'
            }`}
            onClick={() => {
              this.fetchQuestions(0, { dateAskedSortOrder: SortOrder.getInverse(filter.dateAskedSortOrder) });
              trackAnalyticsFeature(VALUE_ADD, ENGAGEMENT_DETAILS, SORT_QANDA);
            }}>
            <HeaderSortComponent headerTitle={t('engagement.submissionTime')} />
          </button>
          <Menu
            isBig={true}
            menuKey="engagementModuleSessionQAndAAnsweredMenu"
            detailsMenu={this.buildOptions()}
            buttonComponent={
              <button className="custom-buttons-chameleon outline-button">
                {this.getSelectedFilterText(filter.answered)} <i className="togo-icon togo-icon-2x togo-icon-chevron" />
              </button>
            }
          />
        </div>
      </div>
    );
  }

  qAndAListComponent() {
    const { sessionQAndAs, page } = this.props.reduced_session_questions;
    const { isBig } = this.props;
    const { timeZone } = this.props.reduced_session_details.sessionDetails || {};
    return (
      <div className="qAndAListComponent">
        {sessionQAndAs.map((qAndA, index) => (
          <QandAComponent
            key={index}
            timeZone={timeZone}
            isBig={isBig}
            qAndAInfo={{
              ...qAndA,
              totalQuestions: page.totalElements,
              currentQuestionIndex: page.size * page.number + index + 1
            }}
          />
        ))}
      </div>
    );
  }

  paginationComponent() {
    const { page, currentPage } = this.props.reduced_session_questions;
    return (
      <div className="paginationComponent">
        <Pagination
          key="session-questions-table-pagination"
          pageIndex={currentPage + 1}
          lastPage={Math.ceil(page.totalElements / page.size)}
          previousDisabled={currentPage === 0}
          nextDisabled={currentPage + 1 === Math.ceil(page.totalElements / page.size)}
          onNextSelected={() => {
            this.fetchQuestions(currentPage + 1);
            trackAnalyticsFeature(VALUE_ADD, ENGAGEMENT_DETAILS, PAGINATE_QANDA);
          }}
          onPreviousSelected={() => {
            this.fetchQuestions(currentPage - 1);
            trackAnalyticsFeature(VALUE_ADD, ENGAGEMENT_DETAILS, PAGINATE_QANDA);
          }}
          onPageSelected={pageDisplayNumber => {
            this.fetchQuestions(pageDisplayNumber - 1);
            trackAnalyticsFeature(VALUE_ADD, ENGAGEMENT_DETAILS, PAGINATE_QANDA);
          }}
        />
      </div>
    );
  }

  fetchQuestions = (pageNumber, filterBy) => {
    const { getSessionQuestions, reduced_session_questions, sessionKey } = this.props;
    const { page, filter: existingFilter } = reduced_session_questions;
    const newFilter = { ...existingFilter, ...filterBy };
    getSessionQuestions(sessionKey, pageNumber, page.size, newFilter);
  };

  buildOptions = () => {
    return getQAndAMenuItems().map(item => {
      let answeredCriteria;

      switch (item.id) {
        case QAndAAnsweredOptions.ALL_POSTS:
          answeredCriteria = null;
          break;
        case QAndAAnsweredOptions.ANSWERED:
          answeredCriteria = true;
          break;
        case QAndAAnsweredOptions.UNANSWERED:
          answeredCriteria = false;
          break;
        default:
          answeredCriteria = null;
          break;
      }

      return {
        onClick: () => {
          this.fetchQuestions(0, { answered: answeredCriteria });
          trackAnalyticsFeature(VALUE_ADD, ENGAGEMENT_DETAILS, FILTER_QANDA);
          trackAnalyticsFilterType(ENGAGEMENT_DETAILS, FILTER_QANDA, null, null, item.id);
        },
        text: item.title,
        id: item.id
      };
    });
  };

  getSelectedFilterText(option) {
    const { t } = this.context;

    if (option === null) {
      return t('engagement.showAllPosts');
    } else if (option === true) {
      return t('engagement.showAnswered');
    } else {
      return t('engagement.showUnAnswered');
    }
  }
}

export default connect(
  state => ({
    reduced_session_questions: state.reduced_session_questions,
    reduced_session_details: state.reduced_session_details
  }),
  {
    getSessionQuestions: sessionQuestionsActions.getSessionQuestions
  }
)(SessionQAndAs);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Engagement/EngagementModal/SessionQAndAs.js